import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Alert,
  Checkbox,
  FormControlLabel,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  DialogActions,
} from '@mui/material';
import HeaderMenu from '../Header/HeaderMenu';
import BillingTable from './BillingTable';
import BillFormDialog from './BillFormDialog';
import BillingConfigDialog from './BillingConfigDialog';
import InvoiceDialog from './InvoiceDialog';
import axiosApi from '../Utils/axiosApi';
import checkPermission from '../Utils/checkPermission';
import UtilitySharedExpenseDialog from './UtilitySharedExpenseDialog';

const HostlerBill = () => {
  const [billingData, setBillingData] = useState([]);
  const [hostelList, setHostelList] = useState([]);
  const [selectedHostelId, setSelectedHostelId] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [alert, setAlert] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [billFormOpen, setBillFormOpen] = useState(false);
  const [billConfigOpen, setBillConfigOpen] = useState(false);
  const [invoiceDialogOpen, setInvoiceDialogOpen] = useState(false);
  const [invoiceHosteler, setInvoiceHosteler] = useState(null);
  const [sendOptions, setSendOptions] = useState({ WhatsApp: true, email: false, sms: false });
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [sending, setSending] = useState(false);
const [utilityExpenseOpen, setUtilityExpenseOpen] = useState(false);

  // Delete dialog
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [hostelerToDelete, setHostelerToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

const [hostelerList, setHostelerList] = useState([]);
const [selectedHosteler, setSelectedHosteler] = useState('');
const [loadingHostelers, setLoadingHostelers] = useState(false);

const [paymentStatusList, setPaymentStatusList] = useState([]);
  // ------------------- API Services -------------------
  const getHostelList = () => axiosApi.post('/hostel/getHostelName', {});
  
  const paymentStatuses = [
  { value: 'COMPLETED', label: 'Paid' },
  { value: 'PARTIALLY_COMPLETED', label: 'Partially Paid' },
  { value: 'PAYMENT_INITIATED', label: 'Payment Initiated' },
  { value: 'NOT_STARTED', label: 'Pending' },
  { value: 'FAILED', label: 'Payment Failed' },
];
  const [onlyBillNotGenerated, setOnlyBillNotGenerated] = useState(false);
  
 const getBillingDataService = (hostelId, billingMonth, hostelerIds, paymentStatusList,onlyBillNotGenerated) =>
  axiosApi.post('/hostelerPayment/getHostelerInvoice', {
    hostelId,
    billingMonth,
    ...(hostelerIds?.length ? { hostelerIds } : {}),
    ...(paymentStatusList?.length ? { paymentStatusList } : {}),onlyBillNotGenerated, // ✅ correct
  });

  const deleteBillService = (id) =>
    axiosApi.post('/hostelerPayment/deleteHostelerInvoice', { hostelerInvoiceIds: [id] });
  const sendBillsService = (invoiceIds, methods, hostelId) =>
    axiosApi.post('/hostelerPayment/sendBills', {
      hostelerInvoiceIds: invoiceIds,
      notificationChannel: methods,
      hostelId,
    });

  // ------------------- Effects -------------------
  useEffect(() => {
    (async () => {
      try {
        const response = await getHostelList();
        const data = Array.isArray(response.data) ? response.data : response.data.hostels || [];
        setHostelList(data.map(([id, name]) => ({ id, hostelName: name })));
      } catch (err) {
        console.error('Error fetching hostels:', err);
      }
    })();
  }, []);

/* ---------------- FETCH HOSTELERS WHEN HOSTEL CHANGES (NEW – ISOLATED) ---------------- */
  const fetchHostelers = async (hostelId) => {
    try {
      setLoadingHostelers(true);
      const response = await axiosApi.post('/hosteler/getHosteler', {
        hostelIds: [Number(hostelId)],
      });

      const data = Array.isArray(response.data) ? response.data : [];

      setHostelerList(
        data.map((h) => ({
          id: String(h.hostelerId || h.id || h[0]),
          hostlerName:
            h.hostlerName ||
            h.hostelerName ||
            `${h.hostlerFirstName || ''} ${h.hostlerLastName || ''}`.trim(),
        }))
      );
    } catch (err) {
      console.error('Error fetching hostelers:', err);
      setHostelerList([]);
    } finally {
      setLoadingHostelers(false);
    }
  };

  useEffect(() => {
    if (selectedHostelId) {
      fetchHostelers(selectedHostelId);
      setSelectedHosteler('');
    } else {
      setHostelerList([]);
      setSelectedHosteler('');
    }
  }, [selectedHostelId]);
  // ------------------- Handlers -------------------
  const fetchBillingData = useCallback(async () => {
	  console.log("fetchBillingData called");
  if (!selectedHostelId || !selectedMonth) {
    setAlert({ type: 'warning', message: 'Please select a hostel and billing month.' });
    return;
  }

  setBillingData([]);
setSelectedInvoiceIds([]);
setAlert({ type: "", message: "" });
setLoading(true);

  try {
    // ✅ ALWAYS send array of numbers
    const hostelerIds =
      selectedHosteler
        ? [Number(selectedHosteler)]   // 🔥 key fix
        : [];

   const response = await getBillingDataService(
  selectedHostelId,
  selectedMonth,
  hostelerIds,
  paymentStatusList,onlyBillNotGenerated
);

    const result = Array.isArray(response.data)
      ? response.data
      : response.data.payments || [];
console.log("Result length:", result.length);

const ids = result.map(r => r.id);
console.log("IDs:", ids);

const uniqueIds = [...new Set(ids)];
console.log("Unique IDs:", uniqueIds.length);
    setBillingData(result);
	console.log("Billing data length:", result.length);

console.table(
  result.map(r => ({
    id: r.id,
    hostelerId: r.hostelerId,
    hostelerName: r.hostelerName
  }))
);
    setAlert({ type: 'success', message: 'Data fetched successfully' });

  } catch {
    setAlert({ type: 'error', message: 'Failed to fetch billing data' });
  } finally {
    setLoading(false);
  }
}, [selectedHostelId, selectedMonth, selectedHosteler,paymentStatusList,onlyBillNotGenerated ]);

  const handleDeleteBill = (id) => {
    setHostelerToDelete(id);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    if (!hostelerToDelete) return;
    setDeleting(true);
    try {
      await deleteBillService(hostelerToDelete);
      setAlert({ type: 'success', message: `Invoice ${hostelerToDelete} deleted.` });
      fetchBillingData();
    } catch {
      setAlert({ type: 'error', message: 'Failed to delete invoice.' });
    } finally {
      setDeleting(false);
      setDeleteDialogOpen(false);
      setHostelerToDelete(null);
    }
  };
const handleViewBill = async (hosteler) => {
  if (!hosteler.invoiceNumber) {
    setAlert({ type: 'warning', message: 'Invoice not generated yet.' });
    return;
  }

  try {
    setLoadingInvoice(true);

    const response = await axiosApi.post(
      "/hostelerPayment/getHostelerInvoice",
      { invoiceNumber: hosteler.invoiceNumber }
    );

    // --- IMPORTANT FIX: API returns array ---
    const dbInvoice = Array.isArray(response.data)
      ? response.data[0]
      : response.data;

    // --- Merge table row + full DB invoice ---
    setInvoiceHosteler({
      ...hosteler,
      ...dbInvoice,
      invoiceExtraChargeDTOs: dbInvoice.invoiceExtraChargeDTOs || [],
      paymentStatus: dbInvoice.paymentStatus || "NOT_STARTED",
    });

    setInvoiceDialogOpen(true);
  } catch (err) {
    console.error("Error fetching invoice:", err);
    setAlert({
      type: "error",
      message: "Failed to fetch invoice details.",
    });
  } finally {
    setLoadingInvoice(false);
  }
};


  const handleSendBill = async () => {
    if (!selectedInvoiceIds.length) {
      setAlert({ type: 'warning', message: 'Select at least one invoice to send.' });
      return;
    }

    const selectedMethods = Object.entries(sendOptions)
      .filter(([_, checked]) => checked)
      .map(([method]) => method);

    if (!selectedMethods.length) {
      setAlert({ type: 'warning', message: 'Select a communication method.' });
      return;
    }

    if (!selectedHostelId) {
      setAlert({ type: 'warning', message: 'Please select a hostel before sending bills.' });
      return;
    }

    try {
      setSending(true);
      const response = await sendBillsService(selectedInvoiceIds, selectedMethods, selectedHostelId);

      setAlert({
        type: 'success',
        message:
          response.data?.message ||
          `Bills successfully sent via ${selectedMethods.join(', ').toUpperCase()}.`,
      });

      await fetchBillingData();
    } catch (err) {
      console.error('Error sending bills:', err);
      const errorMessage =
        err.response?.data?.message ||
        'Failed to send bills. Please check WhatsApp or Email configuration.';
      setAlert({ type: 'error', message: errorMessage });
    } finally {
      setSending(false);
    }
  };

  // ------------------- JSX -------------------
  return (
    <div className="user-list">
      <HeaderMenu />

      {/* 🔹 Filter & Actions Box */}
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          p: 2,
          borderRadius: 2,
          mb: 3,
          boxShadow: 1,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Filter Bills
        </Typography>
{/* 🔹 Responsive Filter Fields */}
<Box sx={{ mt: 2 }}>
  <Grid container spacing={2} alignItems="center">

    {/* Hostel */}
    <Grid item xs={12} sm={6} md={2}>
      <FormControl fullWidth size="small">
        <InputLabel>Hostel</InputLabel>
        <Select
          value={selectedHostelId}
          label="Hostel"
          onChange={(e) => setSelectedHostelId(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {hostelList.map((h) => (
            <MenuItem key={h.id} value={h.id}>
              {h.hostelName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* Hosteler */}
    <Grid item xs={12} sm={6} md={2}>
      <FormControl
        fullWidth
        size="small"
        disabled={!selectedHostelId || loadingHostelers}
      >
        <InputLabel>Hosteler</InputLabel>
        <Select
          value={selectedHosteler}
          label="Hosteler"
          onChange={(e) => setSelectedHosteler(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {hostelerList.map((h) => (
            <MenuItem key={h.id} value={h.id}>
              {h.hostlerName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* Billing Month */}
    <Grid item xs={12} sm={6} md={2}>
      <TextField
        fullWidth
        label="Billing Month"
        type="month"
        size="small"
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    {/* Payment Status */}
    <Grid item xs={12} sm={6} md={2}>
      <FormControl fullWidth size="small">
        <InputLabel>Payment Status</InputLabel>
        <Select
          multiple
          value={paymentStatusList}
          label="Payment Status"
          onChange={(e) => setPaymentStatusList(e.target.value)}
          renderValue={(selected) =>
            selected.length
              ? paymentStatuses
                  .filter((item) => selected.includes(item.value))
                  .map((item) => item.label)
                  .join(", ")
              : "All"
          }
        >
          {paymentStatuses.map((status) => (
            <MenuItem key={status.value} value={status.value}>
              <Checkbox
                checked={paymentStatusList.includes(status.value)}
              />
              {status.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    {/* Bill Not Generated */}
    <Grid item xs={12} sm={6} md={2}>
      <FormControlLabel
        sx={{
          m: 0,
          width: "100%",
        }}
        control={
          <Checkbox
            checked={onlyBillNotGenerated}
            onChange={(e) =>
              setOnlyBillNotGenerated(e.target.checked)
            }
          />
        }
        label="Bill Not Generated"
      />
    </Grid>

    {/* Search Button */}
    <Grid item xs={12} sm={6} md={1}>
      <Button
        fullWidth
        variant="contained"
        onClick={fetchBillingData}
        disabled={loading}
        sx={{ height: 40 }}
      >
        {loading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Search"
        )}
      </Button>
    </Grid>

  </Grid>
</Box>

        {/* 🔹 Responsive Action Buttons */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            mt: 2,
            alignItems: 'center',
          }}
        >
          <Button
            disabled={!checkPermission('Hostel', 'Hosteler Bill', 'VIEWBILLINGCONFIGURATION')}
            variant="contained"
            onClick={() => setBillConfigOpen(true)}
            sx={{ flex: '1 1 200px' }}
          >
            Billing Configuration
          </Button>
					<Button
		  disabled={!checkPermission('Hostel', 'Hosteler Bill', 'VIEWBILLINGCONFIGURATION')}
		  variant="contained"
		  onClick={() => setUtilityExpenseOpen(true)}
		  sx={{ flex: '1 1 200px' }}
		>
		  Utility & Shared Expenses
		</Button>
		<Button
            disabled={!checkPermission('Hostel', 'Hosteler Bill', 'GENERATEBILL')}
            variant="contained"
            onClick={() => setBillFormOpen(true)}
            sx={{ flex: '1 1 200px' }}
          >
            Generate Bill
          </Button>

          <Typography variant="subtitle1" sx={{ flex: '1 1 100%', mt: 1 }}>
            Send via:
          </Typography>

          {['WhatsApp', 'email', 'sms'].map((method) => (
            <FormControlLabel
              key={method}
              control={
                <Checkbox
                  checked={sendOptions[method]}
                  onChange={(e) =>
                    setSendOptions({ ...sendOptions, [method]: e.target.checked })
                  }
                />
              }
              label={method.toUpperCase()}
              sx={{ flex: '1 1 120px' }}
            />
          ))}

          <Button
            variant="contained"
            color="success"
            onClick={handleSendBill}
            disabled={!checkPermission('Hostel', 'Hosteler Bill', 'SENDBILL')}
            sx={{
              flex: '1 1 250px',
              alignSelf: 'center',
            }}
          >
            {sending ? <CircularProgress size={20} color="inherit" /> : 'Send Bill'}
          </Button>
        </Box>

        {alert.message && (
          <Alert severity={alert.type} sx={{ mt: 2 }}>
            {alert.message}
          </Alert>
        )}
      </Box>

      {/* Billing Table */}
      <BillingTable
        data={billingData}
        onDelete={handleDeleteBill}
        onViewBill={handleViewBill}
        onSelectionChange={setSelectedInvoiceIds}
      />

      {/* Dialogs */}
      <BillFormDialog open={billFormOpen} onClose={() => setBillFormOpen(false)} hostelList={hostelList} />
      <BillingConfigDialog open={billConfigOpen} onClose={() => setBillConfigOpen(false)} hostelList={hostelList} />
      <InvoiceDialog open={invoiceDialogOpen} onClose={() => setInvoiceDialogOpen(false)} hosteler={invoiceHosteler} loading={loadingInvoice} />
	  <UtilitySharedExpenseDialog open={utilityExpenseOpen} onClose={() => setUtilityExpenseOpen(false)} hostelList={hostelList}/>

      {/* Delete Confirmation */}
      <Dialog open={isDeleteDialogOpen} onClose={() => setDeleteDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this record?</p>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={confirmDelete} disabled={deleting}>
            {deleting ? <CircularProgress size={20} color="inherit" /> : 'Yes, Delete'}
          </Button>
          <Button variant="outlined" onClick={() => setDeleteDialogOpen(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HostlerBill;
